// Query keys for React Query caching and invalidation
export const manageQueryKeys = {
  // Tenant queries
  tenants: ['manage', 'tenants'] as const,
  tenant: (tenantId: string) => ['manage', 'tenant', tenantId] as const,

  // User queries
  users: ['manage', 'users'] as const,
  usersByTenant: (tenantId: string) => ['manage', 'users', 'tenant', tenantId] as const,
  user: (userId: string) => ['manage', 'user', userId] as const,

  // User role queries
  userRoles: ['manage', 'userRoles'] as const,
  userRolesByUser: (userId: string) => ['manage', 'userRoles', 'user', userId] as const,
  usersByRole: (role: string) => ['manage', 'users', 'role', role] as const,

  // Admin specific queries
  systemAdmins: ['manage', 'systemAdmins'] as const,

  // User existence check
  userExists: (email: string) => ['manage', 'userExists', email] as const,
} as const;
